import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@fontsource-variable/inter";

import AppProviders from "./app/AppProviders";
import Auth from "./hooks/AuthContext";
import Loading from "./components/Loading";
import AppRoutes from "./routes";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppProviders>
      <BrowserRouter>
        <Auth>
          <Suspense fallback={<Loading />}>
            <AppRoutes />
          </Suspense>
        </Auth>
      </BrowserRouter>
    </AppProviders>
  </React.StrictMode>
);
